/**
 * Analytics Event Tracking
 *
 * Simple event tracking helper that logs to console.
 * Can be replaced with a real analytics provider later
 * without touching call sites.
 */

import * as Sentry from '@sentry/react';

export function trackEvent(name: string, payload?: Record<string, any>): void {
  console.info('[analytics]', name, payload);
}

/**
 * Track user click events via Sentry breadcrumbs.
 * Events are captured in Sentry session data for analysis.
 */
export function trackClick(eventName: string, data?: Record<string, unknown>) {
  Sentry.addBreadcrumb({
    category: 'user-action',
    message: eventName,
    level: 'info',
    data: {
      ...data,
      timestamp: new Date().toISOString(),
      path: typeof window !== 'undefined' ? window.location.pathname : '',
    }
  });

  // Log to console in development
  if (import.meta.env.DEV) {
    console.log(`[Analytics] ${eventName}`, data);
  }
}
